import { IPromise } from 'angular';
import { IPagedResult } from '../../tn.django/django-client.service/djangoClient';
import { IDjangoFontStyle, IFontStyleModel } from '../classes';
import {
    FontPosture,
    FontWeight,
    FontWidth,
    isFontPosture,
    isFontWeight,
    isFontWidth,
} from '../constants';
import { latinize } from '../functions/latinize';
import { FontListParams } from './FontRepository';
import { FontStyleRepository } from './FontStyleRepository';

export function mapIDjangoFontStyleToIFontStyleModel(
    style: IDjangoFontStyle
): IFontStyleModel {
    const min_recommended_size = style.min_recommended_size || 8;
    const max_recommended_size = style.max_recommended_size || 250;
    const latin_name = latinize(style.name);
    const srefParams = {
        familyName: style.family_slug,
        foundryEESubdomain: style.ee_subdomain,
        styleName: style.slug,
    };

    // for some reason is doesn't like 'variable' here even thought its
    // part of the FontPosture enum
    const djangoPosture = style.posture;
    const posture: FontPosture = isFontPosture(djangoPosture)
        ? djangoPosture
        : 'variable';
    const djangoWeight = style.weight;
    const weight: FontWeight = isFontWeight(djangoWeight)
        ? djangoWeight
        : 'variable';
    const djangoWidth = style.width;
    const width: FontWidth = isFontWidth(djangoWidth)
        ? djangoWidth
        : 'variable';

    const model: IFontStyleModel = {
        ...style,
        latin_name,
        label: style.name,
        getSrefParams: () => srefParams,
        min_recommended_size,
        max_recommended_size,
        posture,
        weight,
        width,
    };
    return model;
}

export class FontStyleService {
    static $inject = ['FontStyleRepository'];
    constructor(protected repository: FontStyleRepository) {}

    _map(style: IDjangoFontStyle): IFontStyleModel {
        return mapIDjangoFontStyleToIFontStyleModel(style);
    }

    get(id: number): IPromise<IFontStyleModel> {
        return this.repository.get(id).then((style) => this._map(style));
    }

    list(filters: FontListParams): IPromise<IPagedResult<IFontStyleModel>> {
        return this.repository.list(filters).then((response) => {
            const styles = response.results.map((style) => this._map(style));

            return {
                ...response,
                // fitler out any undefineds from the list. these were not visible for some reason.
                results: styles,
            };
        });
    }
}

export class FontStylePublicService extends FontStyleService {
    static $inject = ['FontStylePublicRepository'];
}
